import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {graphql} from 'react-relay';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation applyAutoScheduleChangesMutation($input: ApplyAutoScheduleChangesInput!) {
		applyAutoScheduleChanges(input: $input) {
			project {
				projectPersons(first: 10000) {
					edges {
						node {
							id
							isContactPerson
							person {
								id
								firstName
								lastName
								fullName
							}
							role {
								id
								name
							}
						}
					}
				}
			}
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Auto schedule changes applied');
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};
	return trackAndCommitMutation(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
